// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n:target:before {\n    content: \"\";\n    display: block;\n    height: 80px;\n}\nhr {\n    background-color: #000000;\n    height: 3px;\n    border: none;\n}\n.cover-image {\n    margin-bottom: 50px;\n    width: 100%;\n    height: 400px;\n}\n.fs-btn {\n    margin-left: 30px;\n    margin-bottom: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
